import { render, staticRenderFns } from "./profileHeader.vue?vue&type=template&id=6a785a9e&scoped=true&"
import script from "./profileHeader.vue?vue&type=script&lang=js&"
export * from "./profileHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a785a9e",
  null
  
)

export default component.exports